import processPlayerStatsBasketball from "./processPlayerStats.basketball.ts";
import type { PlayerStats, PlayerStatType } from "./types.ts";

// ONLY USE THIS IF THE fantasySports SETTING DOES NOT MATTER!!! Otherwise, use it from ui/worker
export const processPlayerStats = (
	ps: PlayerStats,
	stats: string[],
	statType?: PlayerStatType,
	bornYear?: number,
) => {
	return processPlayerStatsBasketball(ps, stats, statType, bornYear);
};
